export const BASE_URL = '/finance/debt'
export const PAGE_SIZE = 10

export const FILTER_CONFIG_DEBT = {
  id: { type: 'string' as const },
  walletIds: { type: 'array' as const },
  dateFilter: { type: 'string' as const, default: 'date' },
  dateFrom: { type: 'string' as const },
  dateTo: { type: 'string' as const },
  userId: { type: 'string' as const },
  statuses: { type: 'array' as const },
  sorterField: { type: 'string' as const, default: '-dateTime' },
  page: { type: 'string' as const, default: '1', pagination: true },
  pageSize: { type: 'string' as const, default: '10', pagination: true },
}
